import type { ComponentType } from 'react';

import type { SWReactIconProps } from '@similarweb/icons';

export type Tab<T> = {
  name: T;
  component: ComponentType;
  label: string;
  iconProps?: SWReactIconProps & { colorMethod?: 'stroke' | 'fill'; width?: number };
  isBeta?: boolean;
};
